import styled from "styled-components";
import { theme } from "../../../../styles/theme";

export const Thumb = styled.div`
  margin-bottom: 20px;
`;

export const ThumbImageWrapper = styled.div`
  width: 110px;
  height: 94px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: ${theme.border.mediumRadius};
  border: 1px dashed ${theme.colors.green3};

  object-fit: contain;
  overflow: hidden;
`;

export const ThumbImage = styled.img`
  object-fit: contain;
  height: 100%;
`;

export const Upload = styled.form`
  width: 100%;

  & > span {
    font-size: ${theme.font.sizes.xxsmall};
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.black};
    width: 100%;
  }

  & > div {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  & > div > label {
    padding: 6px 12px;
    height: 45px;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 16px;
    font-family: ${theme.font.poppins};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.white};

    cursor: pointer;
    background-color: ${theme.colors.darkBlue};
    border-radius: 8px;
    border: 1px solid #b9c1cb;
  }

  & > div > input {
    display: none;
  }
`;

export const NameWrapper = styled.div`
  height: 16px;

  display: flex;
  align-items: center;

  gap: 15px;

  & > span {
    overflow: hidden;
    max-width: 200px;

    font-size: 16px;
    font-family: ${theme.font.poppins};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.white};
    white-space: nowrap;
    text-overflow: ellipsis;

    @media screen and (max-width: 768px) {
      max-width: 50px;
    }
  }

  & > button {
    background: none;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px !important;
  align-items: flex-start !important;

  & > span {
    font-size: ${theme.font.sizes.xxsmall};
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.black};
  }
`;

export const ContainerFile = styled.div`
  width: 100%;
  height: 45px;

  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const DownloadButton = styled.button`
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 8px;

  font-size: 12px;
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.white};

  cursor: pointer;
  background-color: ${theme.colors.darkBlue};
  border-radius: 8px;
  border: 1px solid #b9c1cb;

  padding: 6px 12px;
`;

export const ChangeButton = styled.button`
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 8px;

  font-size: 12px;
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.white};

  cursor: pointer;
  background-color: ${theme.colors.darkBlue};
  border-radius: 8px;
  border: 1px solid #b9c1cb;

  padding: 6px 12px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
